import UploadHistory from './UploadHistory';

export default UploadHistory;
